/**
 * Ícone do Google Agenda — moldura nas quatro cores do Google, como o app.
 * Inline para não depender de asset externo; herda o tamanho por className.
 */
export default function GoogleCalendarIcon({ className = "h-3 w-3" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={`shrink-0 ${className}`} aria-hidden="true">
      <rect x="4" y="4" width="16" height="16" rx="1" fill="#fff" />
      <path d="M4 4h16v4H4z" fill="#4285F4" />
      <path d="M16 4h4v16h-4z" fill="#34A853" />
      <path d="M4 16h16v4H4z" fill="#FBBC04" />
      <path d="M4 4h4v16H4z" fill="#EA4335" />
      <path d="M16 16h4v4h-4z" fill="#188038" />
      <path d="M4 16h4v4H4z" fill="#C5221F" />
      <rect x="8" y="8" width="8" height="8" fill="#fff" />
      <text x="12" y="14.3" textAnchor="middle" fontSize="6.5" fontWeight="700" fill="#1a73e8" fontFamily="system-ui, sans-serif">31</text>
    </svg>
  );
}
